export default "__VITE_ASSET__f3eca371__"